import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { BehaviouralRuleType } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/asset-field"

export class AssignmentFieldOptionsVM extends CommonOptionVM {
  required?: boolean;
  editable?: boolean;
  field_key?: string | null;
  value_type?: BehaviouralRuleType | null;

  constructor(data: Partial<AssignmentFieldOptionsVM> = {}) {
    super(data)
    this.required = data.required ?? undefined
    this.editable = data.editable ?? undefined
    this.field_key = data.field_key || undefined
    this.value_type = this.field_key ? (data.value_type ?? undefined) : undefined
  }

  validateData() {
    const errors: any[] = []
    if (this.field_key && !this.value_type) {
      errors.push({ key: 'value_type', error_message: '"Value type" must not be null when "Field key" is selected' })
    }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default AssignmentFieldOptionsVM